import { render, staticRenderFns } from "./Menubar.vue?vue&type=template&id=252ceb47&scoped=true"
import script from "./Menubar.vue?vue&type=script&lang=js"
export * from "./Menubar.vue?vue&type=script&lang=js"
import style0 from "./Menubar.vue?vue&type=style&index=0&id=252ceb47&prod&scoped=true&lang=css"
import style1 from "./Menubar.vue?vue&type=style&index=1&id=252ceb47&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ceb47",
  null
  
)

export default component.exports